import { RequestResourcesByIds } from "../dtos/resource";
import Server from "./index";

export default class ResourceServer extends Server {
  constructor() {
    super("/index.php");
  }

  public get(params: RequestResourcesByIds): Promise<any> {
    return super.get(params);
  }
}
